import { render, staticRenderFns } from "./InstitutionTypeInput.vue?vue&type=template&id=d87495d4"
import script from "./InstitutionTypeInput.vue?vue&type=script&lang=js"
export * from "./InstitutionTypeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports